import dynamic from 'next/dynamic';

import {
  Box,
  Grid,
} from '@mui/material';

import { useTheme } from '@mui/material/styles';


const ReactSpeedometer = dynamic(() => import ("react-d3-speedometer"), { ssr: false })


const CostEstimateSummary = ({make, model, service, estimate}) => {
  const theme = useTheme();

  return (
    <Grid container spacing={6}>
      <Grid item xs={12} md={6}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box mb={2} mt={4}>Summary of all past quotes received for:</Box>
          <Box
            sx={{
              my: 2,
              fontSize: "h6.fontSize",
              color: "primary.light",
              textAlign: "center"
            }}
          >
            {make} {model} {service}
          </Box>
          <Box my={2} fontSize="35px" fontWeight={600}>
            R{estimate.estimate_25th} <small style={{fontWeight: 400}}>to</small> R{estimate.estimate_75th}
          </Box>
          <Box mb={0.5} fontSize="h6.fontSize">
            Estimated from <b>{estimate.estimate_count}</b> past estimates
          </Box>
          <Box fontSize="h6.fontSize">
            The middlemost quote was <b>R{estimate.estimate_median}</b>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box minHeight="270px" maxWidth="400px" mb={-4} mt={2} mx="auto">
          <ReactSpeedometer
            fluidWidth={true}
            minValue={estimate.estimate_min}
            maxValue={estimate.estimate_max}
            value={estimate.estimate_median}
            currentValueText={`R ${estimate.estimate_median}`}
            needleColor={theme.palette.secondary.main}
            segments={10}
            maxSegmentLabels={5}
            startColor={theme.palette.primary.light}
            endColor="#ededed"
            needleTransitionDuration={4000}
            needleTransition="easeElastic"
            needleHeightRatio={0.8}
            valueTextFontSize={"36px"}
            paddingVertical={16}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default CostEstimateSummary;
